import { getFloatArrayType, proxyAsModuleWithBindings } from '../../run/run-helpers.js';

const createCommonsModule = (rawModule, metadata) => {
    const floatArrayType = getFloatArrayType(metadata.settings.audio.bitDepth);
    return proxyAsModuleWithBindings(rawModule, {
        getArray: {
            type: 'proxy',
            value: (arrayName) => rawModule.globals.commons.getArray(arrayName),
        },
        setArray: {
            type: 'proxy',
            value: (arrayName, array) => rawModule.globals.commons.setArray(arrayName, new floatArrayType(array)),
        },
    });
};

export { createCommonsModule };
